import { Pipe, PipeTransform } from '@angular/core';
import { coberturaEnum } from '../components/api/models/coberturaEnum';

@Pipe({
  name: 'coberturaEnum'
})

export class CoberturaEnumPipe implements PipeTransform {

  transform(value: coberturaEnum | string | undefined): string {
    if (value === undefined || value === null) {
      return 'Desconhecido';
    }
    return TipoNaturezaEnumDescriptions[value as coberturaEnum] || 'Desconhecido';
  }

}

export const TipoNaturezaEnumDescriptions: { [key in coberturaEnum]: string } = {
  0: "Total",
  1: "Parcial",
};
